<div class="doc-insidecard">

  <div *ngIf="isLoading" class="loader">
    <mat-progress-spinner mode="indeterminate" diameter="48"></mat-progress-spinner>
  </div>

  <!-- ✅ Stepper View -->
  <ng-container *ngIf="navigateToStepperForm && !isLoading">
    <wm-app class="view"></wm-app>
  </ng-container>

  <!-- ✅ Summary View (for Renewed applications) -->
  <ng-container *ngIf="navigateToSummary">
    <wm-application-summary
      [appId]="row?.createdApplicationId"
      [renderPrintMode]="true">
    </wm-application-summary>
  </ng-container>

</div>
